export default "__VITE_ASSET__CQte4JhH__"